class OrrlingPilotDiamond extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.scope = this.closest('.shopify-section');
    const options = { signal: this.controller.signal };
    this.scope.addEventListener('change', () => this.sync(), options);
    this.scope.addEventListener('variant:update', () => this.sync(), options);
    this.querySelector('a').addEventListener('click', event => {
      if (!this.sync()) event.preventDefault();
    }, options);
    this.sync();
  }
  disconnectedCallback() { this.controller?.abort(); }
  sync() {
    const picker = this.scope.querySelector('variant-picker');
    const selected = [...picker.querySelectorAll('select[name^="options["]')].map(select => select.value);
    const variant = this.variants.find(v => v.options.length === selected.length && v.options.every((value, i) => value === selected[i]));
    const link = this.querySelector('a');
    if (!variant) { link.setAttribute('aria-disabled', 'true'); return false; }
    const carat = Number.parseFloat(variant.option3.replace(',', '.'));
    if (!Number.isFinite(carat)) { link.setAttribute('aria-disabled', 'true'); return false; }
    const url = new URL(link.href, location.origin);
    url.searchParams.set('settingId', this.dataset.productId);
    url.searchParams.set('settingVariantId', String(variant.id));
    url.searchParams.set('carats_min', carat.toFixed(2));
    url.searchParams.set('carats_max', carat.toFixed(2));
    url.searchParams.set('shapes', this.dataset.shape || 'round');
    link.href = url.href;
    link.removeAttribute('aria-disabled');
    return true;
  }
}
if (!customElements.get('orrling-pilot-diamond')) customElements.define('orrling-pilot-diamond', OrrlingPilotDiamond);
